import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=213d61cc&scoped=true&"
import script from "./WhatsApp.vue?vue&type=script&lang=ts&"
export * from "./WhatsApp.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=213d61cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d61cc",
  null
  
)

export default component.exports